<template>
<BootstrapCard v-if="wrapper == 'page'" v-bind="{ ...$attrs, ...props }">
  <template v-for="name in Object.keys(slots)" v-slot:[name]="slotData" :key="name">
    <slot :name="name" v-bind="slotData" />
  </template>
</BootstrapCard>
<BootstrapModalContent v-else ref="modal" v-bind="$attrs">
  <template v-for="name in Object.keys(slots)" v-slot:[name]="slotData" :key="name">
    <slot :name="name" v-bind="slotData" />
  </template>
</BootstrapModalContent>
</template>
<script setup lang="ts">
import { inject, ref, useSlots } from 'vue';

import BootstrapCard from '#src/vue/BootstrapCard.vue';
import BootstrapModalContent from '#src/vue/BootstrapModalContent.vue';

const slots = useSlots()

const card = ref()
const modal = ref()

const props = withDefaults(
  defineProps<{
    expanded?: boolean
    cardAlwaysExpanded?: boolean
  }>(),
  {
    expanded: true,
    cardAlwaysExpanded: false,
  }
)

const wrapper = inject<'page' | 'modal'>('wrapper', 'page')

defineExpose({
  modal: modal,
  card: card,
})

defineOptions({
  inheritAttrs: false,
})
</script>
